export const SocketEvents = {
    // Message Events
    MESSAGE: {
      RECEIVE: 'message:receive',
      UPDATE: 'message:update',
      DELETE: 'message:delete'
    },
    
    // Order Events
    ORDER: {
      CREATED: 'order:created',
      UPDATED: 'order:updated',
      DELETED: 'order:deleted',
      CANCEL: 'order:cancel',
      STATUS_UPDATED: 'order:status:updated',
      BULK_UPDATE: 'order:bulk:update',
      STATUS_CHANGED: 'order:status:changed'
    },
  
    SHIPMENT: {
      CREATED: 'shipment:created',
      UPDATED:'shipment:updated',
      CANCEL:'shipment:cancel',
      BULK_UPDATE:'shipment:bulk:update',
      STATUS_UPDATE:'shipment:status:update',
      STATUS_CHANGED:'shipment:status:changed'
    },
  
    NDR: {
      CREATED:'ndr:created',
      UPDATED:'ndr:updated',
      DELETED:'ndr:deleted',
      STATUS_UPDATE:'ndr:status:update',
    },
  
    WEIGHT_DISPUTE: {
      CREATED:'weightDispute:created',
      UPDATED:'weightDispute:updated',
      DELETED:'weightDispute:deleted',
      ACTION_UPDATED:'weightDispute:action:updated',
      RAISE_DISPUTE:'weightDispute:raise:dispute',
      ACCEPTED:'weightDispute:accepted',
    },
  
    WALLET: {
      TRANSACTION_CREATED:'wallet:transaction:created',
      TRANSACTION_UPDATED:'wallet:transaction:updated',
      TRANSACTION_DELETED:'wallet:transaction:deleted',
      WALLET_UPDATED:'wallet:updated',
      WALLET_DELETED:'wallet:deleted',
      WALLET_CREATED:'wallet:created',
      WALLET_BALANCE_UPDATED:'wallet:balance:updated',
    },
  
    KYC: {
      CREATED:'kyc:created',
      UPDATED:'kyc:updated',
    },
    NOTIFICATION: {
      CREATED:'notification:created',
      UPDATED:'notification:updated',
      DELETED:'notification:deleted',
      BROADCAST:'notification:broadcast',
    },
  
    ESCALATION: {
      CREATED:'escalation:created',
      UPDATED:'escalation:updated',
      DELETED:'escalation:deleted',
    },
    // System Events
    SYSTEM: {
      NOTIFICATION: 'system:notification',
      ALERT: 'system:alert'
    },
    CHANNEL: {
      CREATED:'channel:created',
      UPDATED:'channel:updated',
      DELETED:'channel:deleted',
    },
    COURIER: {
      CREATED:'courier:created',
      UPDATED:'courier:updated',
      DELETED:'courier:deleted',
    },
    USER_CHANNEL: {
      CREATED:'userChannel:created',
      UPDATED:'userChannel:updated',
      DELETED:'userChannel:deleted',
    },
    USER_COURIER: {
      CREATED:'userCourier:created',
      UPDATED:'userCourier:updated',
      DELETED:'userCourier:deleted',
    },
  };
  
  // Validation pattern: resource:action or resource:scope:action
  export const isValidEventName = (event) => 
    /^[a-z]+(:[a-z]+){1,2}$/.test(event);